export default "__VITE_PUBLIC_ASSET__c8d261d6__"